"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const lodash_1 = require("lodash");
const error_1 = __importDefault(require("@atlaskit/icon/glyph/error"));
const info_1 = __importDefault(require("@atlaskit/icon/glyph/info"));
const check_circle_1 = __importDefault(require("@atlaskit/icon/glyph/check-circle"));
const warning_1 = __importDefault(require("@atlaskit/icon/glyph/warning"));
const { AutoDismissFlag: AkAutoDismissFlag, FlagGroup: AkFlagGroup } = require("@atlaskit/flag");
const AkFlag = require("@atlaskit/flag").default;
const { colors } = require("@atlaskit/theme");
const icons = {
    info: react_1.default.createElement(info_1.default, { label: "Info icon", primaryColor: colors.N500 }),
    success: react_1.default.createElement(check_circle_1.default, { label: "Success", primaryColor: colors.G300 }),
    warning: react_1.default.createElement(warning_1.default, { label: "Warning icon", primaryColor: colors.Y300 }),
    error: react_1.default.createElement(error_1.default, { label: "Error icon", primaryColor: colors.R300 })
};
exports.FlagContext = react_1.default.createContext({
    showFlag: () => { }
});
class FlagProvider extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.state = {
            flags: []
        };
        this.showFlag = (flag) => {
            if (lodash_1.find(this.state.flags, flag)) {
                return;
            }
            const flags = this.state.flags.slice();
            flags.unshift(flag);
            this.setState({ flags });
        };
        this.dismissFlag = () => {
            this.setState(state => ({
                flags: state.flags.slice(1)
            }));
        };
    }
    render() {
        return (react_1.default.createElement(exports.FlagContext.Provider, { value: { showFlag: this.showFlag } },
            react_1.default.createElement("div", null,
                react_1.default.createElement(AkFlagGroup, { onDismissed: this.dismissFlag }, this.state.flags.map((flag, index) => flag.disableAutoDismiss ? (react_1.default.createElement(AkFlag, { icon: flag.type ? icons[flag.type] : "normal", title: flag.title, description: flag.message, id: this.state.flags.length - 1 - index, key: this.state.flags.length - 1 - index })) : (react_1.default.createElement(AkAutoDismissFlag, { icon: flag.type ? icons[flag.type] : "normal", title: flag.title, description: flag.message, id: this.state.flags.length - 1 - index, key: this.state.flags.length - 1 - index }))))),
            this.props.children));
    }
}
exports.FlagProvider = FlagProvider;
exports.withShowFlag = (WrappedComponent) => { var _a; return _a = class WithShowFlag extends react_1.Component {
        render() {
            return (react_1.default.createElement(exports.FlagContext.Consumer, null, ({ showFlag }) => (react_1.default.createElement(WrappedComponent, Object.assign({}, this.props, { showFlag: showFlag })))));
        }
    },
    _a.displayName = WrappedComponent.name,
    _a.WrappedComponent = WrappedComponent,
    _a; };
exports.useShowFlag = () => {
    const ctx = react_1.useContext(exports.FlagContext);
    return ctx.showFlag;
};
exports.MockFlagProvider = props => (react_1.default.createElement(exports.FlagContext.Provider, { value: { showFlag: props.showFlag } }, props.children));
